function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import styled from "styled-components";
import propTypes from "prop-types";
import Checkbox from "./checkbox";
import InputError from "../input-error";
import { getLocalizedProperty } from "../../utils/i18n";
import Label from "../label";
import { MutedText } from "../text";
var CheckboxesContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.checkboxGroup.container;
});
var CheckboxLabel = styled.label(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.components.checkboxGroup.label;
});
var CheckboxContainer = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.components.checkboxGroup.checkbox;
});
var CheckboxGroup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(CheckboxGroup, PureComponent);
    var _super = _createSuper(CheckboxGroup);
    function CheckboxGroup() {
        _classCallCheck(this, CheckboxGroup);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleChange = function(e) {
            var _props = _this.props, values = _props.values, onChange = _props.onChange;
            var value = e.target.value;
            var valueIndex = values.indexOf(value);
            var newValues = [];
            if (valueIndex !== -1) {
                newValues = _toConsumableArray(values.slice(0, valueIndex)).concat(_toConsumableArray(values.slice(valueIndex + 1)));
            } else {
                newValues = _toConsumableArray(values).concat([
                    value
                ]);
            }
            var newEvent = {
                target: {
                    name: _this.props.name || _this.props.label,
                    value: newValues
                }
            };
            if (onChange) {
                onChange(newEvent);
            }
        };
        _this.isControlled = "values" in _this.props;
        _this.renderCheckbox = function(option) {
            var _props = _this.props, optionMappings = _props.optionMappings, renderCheckbox = _props.renderCheckbox;
            var value = option[(optionMappings === null || optionMappings === void 0 ? void 0 : optionMappings.value) || "value"];
            var label = getLocalizedProperty(option, (optionMappings === null || optionMappings === void 0 ? void 0 : optionMappings.label) || "label");
            var key = option.id || "".concat(label, "_").concat(value);
            var isChecked = _this.props.values.includes(value);
            var checkbox = /*#__PURE__*/ React.createElement(CheckboxContainer, {
                key: key,
                vertical: _this.props.vertical
            }, /*#__PURE__*/ React.createElement(CheckboxLabel, {
                className: isChecked ? "checkbox-checked" : ""
            }, /*#__PURE__*/ React.createElement(Checkbox, _extends({
                id: key,
                name: _this.props.name || _this.props.label,
                disabled: _this.props.disabled || option.disabled,
                value: value,
                onChange: _this.handleChange
            }, _this.isControlled ? {
                checked: isChecked
            } : {})), label));
            if (renderCheckbox) {
                return renderCheckbox(checkbox, key, option, isChecked);
            } else {
                return checkbox;
            }
        };
        return _this;
    }
    var _proto = CheckboxGroup.prototype;
    _proto.render = function render() {
        var _props = this.props, label = _props.label, helpText = _props.helpText, options = _props.options, error = _props.error;
        return /*#__PURE__*/ React.createElement("fieldset", null, /*#__PURE__*/ React.createElement(Label, null, label), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement(CheckboxesContainer, null, options.map(this.renderCheckbox)), error && /*#__PURE__*/ React.createElement(InputError, null, error));
    };
    return CheckboxGroup;
}(PureComponent);
CheckboxGroup.propTypes = {
    label: propTypes.string,
    options: propTypes.array.isRequired,
    onChange: propTypes.func,
    disabled: propTypes.bool,
    optionMappings: propTypes.object,
    values: propTypes.array,
    vertical: propTypes.bool,
    name: propTypes.string,
    error: propTypes.string
};
CheckboxGroup.defaultProps = {
    optionMappings: {
        value: "value",
        label: "label"
    }
};
export default CheckboxGroup;
